import { Component } from '@angular/core';
import { NavController,ToastController } from 'ionic-angular';
import * as firebase from 'firebase/app';

@Component({
  selector: 'page-accounts',
  templateUrl: 'accounts.html'
})
export class AccountsPage{
  accounts= [];
  account= {};
  rol = [];
  prevrol = [];
  roles;
  rolesarr;
  //accounts =  [];
  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController
  ){
    /* this.accounts = af.list('/accounts'); */
    firebase.database().ref('/groups/categories').once('value')
      .then((snap1)=> {
        this.roles = snap1.val();
        this.rolesarr = Object.keys(snap1.val());
      });
  }

  prevRol(rol){
      let role = rol;
      if(typeof rol == "undefined" || rol==-1) role = [];
      this.prevrol = role;
  }

  updateRol(user){
    /* for(let i=0;i<this.rolesarr.length;i++){
      let oldrol = this.prevrol.indexOf(this.rolesarr[i]);
      let newrol = user.role.indexOf(this.rolesarr[i]);
      if(oldrol==-1 && newrol>=0){ //nuevo en el rol
        //this.rol = this.af.list('groups/data/'+this.rolesarr[i]);
        this.rol.push(user.email);
      }else if(oldrol>=0 && newrol==-1){ //se elimina rol
        firebase.database().ref('groups/data/'+this.rolesarr[i]).once('value')
          .then((snap1)=> {
            if(snap1.exists()){
              this.rol = this.af.list('groups/data/'+this.rolesarr[i]);
              let emails = snap1.val();
              for(let i=0;i<Object.keys(emails).length;i++){
                if(emails[Object.keys(emails)[i]]==user.email){
                  this.rol.remove(Object.keys(emails)[i]);
                  break;
                }
              }
            }
          });
      }
    }

     this.account = this.af.object('accounts/'+user.$key+'/role');
    this.account.set(user.role).then(_ => {
      let toast = this.toastCtrl.create({
        message: 'Se ha cambiado Rol a '+user.name+' exitosamente',
        duration: 3000
      });
      toast.present();
    }); */

  }

  updateActive(user){
    /* this.account = this.af.object('accounts/'+user.$key+'/active');
    this.account.set(user.active).then(_ => {
      let toast = this.toastCtrl.create({
        message: 'Se ha cambiado estado a '+user.name+' exitosamente',
        duration: 3000
      });
      toast.present();
    }); */
  }

}



// WEBPACK FOOTER //
// ./src/pages/accounts/accounts.ts